import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslations } from 'next-intl';

import { $apiWithoutClient, errorHandler } from 'modules/global';

import { profileConst } from '..';

export function useUpdateUser(onClose: () => void) {
  const t = useTranslations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData: FormData) => {
      const { data } = await $apiWithoutClient.post(`/profile/update`, userData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [profileConst.queryKeys.USER_PROFILE_INFO] });

      onClose();

      message.success(t('saqlandi'));
    },
    onError: errorHandler()
  });
}
